import { useNavigate } from 'react-router-dom';

interface Vehicle {
  id: number;
  year: number;
  make: string;
  model: string;
  trim: string;
  mileage: number;
  estimatedValue: number;
  images: string[];
  location: string;
  condition: string;
}

interface SimilarVehiclesProps {
  vehicles: Vehicle[];
}

export default function SimilarVehicles({ vehicles }: SimilarVehiclesProps) {
  const navigate = useNavigate();

  return (
    <div className="mt-12">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Similar Vehicles</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {vehicles.map((vehicle) => (
          <div
            key={vehicle.id}
            onClick={() => navigate(`/vehicle-detail?id=${vehicle.id}`)}
            className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-all cursor-pointer group"
          >
            <div className="relative w-full h-48 bg-gray-100 overflow-hidden">
              <img
                src={vehicle.images[0]}
                alt={`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-3 right-3 px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-sm font-semibold text-gray-900">
                ${vehicle.estimatedValue.toLocaleString()}
              </div>
            </div>
            <div className="p-4">
              <h3 className="font-bold text-gray-900 mb-1 group-hover:text-teal-600 transition-colors">
                {vehicle.year} {vehicle.make} {vehicle.model}
              </h3>
              <p className="text-sm text-gray-600 mb-3">{vehicle.trim}</p>
              <div className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-1 text-gray-600">
                  <i className="ri-speed-line"></i>
                  <span>{vehicle.mileage.toLocaleString()} mi</span>
                </div>
                <div className="flex items-center gap-1 text-gray-600">
                  <i className="ri-map-pin-line"></i>
                  <span>{vehicle.location}</span>
                </div>
              </div>
              <div className="mt-3 pt-3 border-t border-gray-200">
                <span className="inline-block px-3 py-1 bg-teal-50 text-teal-700 text-xs font-medium rounded-full">
                  {vehicle.condition}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
